/* eslint-disable import/prefer-default-export */
import graphqlClient from '../graphql';
import {
  listInvoiceGroupProductPricingsGql,
  listProductPricingsGql,
  updateInvoiceGroupProductPricingsGql,
  updateProductPricingsGql,
} from './gql';

export const listProductPricingsApi = () => {
  return graphqlClient
    .request(listProductPricingsGql)
    .then(({ listProductPricings }) => listProductPricings);
};

export const listInvoiceGroupProductPricingsApi = ({ invoiceGroupId }) => {
  return graphqlClient
    .request(listInvoiceGroupProductPricingsGql, { invoiceGroupId })
    .then(({ listInvoiceGroupProductPricings }) => listInvoiceGroupProductPricings);
};

// Saves rows to the default price list (add or update by NDC); resolves to the rows as stored.
export const updateProductPricingsApi = ({ productPricings }) => {
  return graphqlClient
    .request(updateProductPricingsGql, { productPricings })
    .then(({ updateProductPricings }) => updateProductPricings);
};

// Saves rows to one invoicing group's overrides (add or update by NDC).
export const updateInvoiceGroupProductPricingsApi = ({ invoiceGroupId, productPricings }) => {
  return graphqlClient
    .request(updateInvoiceGroupProductPricingsGql, { invoiceGroupId, productPricings })
    .then(({ updateInvoiceGroupProductPricings }) => updateInvoiceGroupProductPricings);
};
